import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/deposits/new/loading';

export const Route = createFileRoute('/_private/deposits/new')({
  pendingComponent: Loading,
});
